
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/good-news-today-livetv",
      function () {
        return require("private-next-pages/good-news-today-livetv.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/good-news-today-livetv"])
      });
    }
  